export default __webpack_public_path__ + "static/media/criteria.17bcab20.png";